module.exports = __webpack_public_path__ + "img/placemark.4910cffa.svg";